// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h4[data-v-aece9636]{font-size:.8125rem !important;line-height:3.38;margin-bottom:2rem;opacity:.3}", ""]);
// Exports
module.exports = exports;
